var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"app-nav"},_vm._l((_vm.visibleItems),function(item){return _c('button',{key:item.id,staticClass:"nav-item",class:{ active: _vm.current === item.id },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('change', item.id)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }